import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MaterialPage} from './material';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';

@NgModule({
  declarations: [
    MaterialPage,
  ],
  imports: [
    IonicPageModule.forChild(MaterialPage),
    CalendarModule,
  ],

  entryComponents: [
  ],
  providers: [
    RestProvider,
  ]
})
export class MaterialPageModule {}



// WEBPACK FOOTER //
// ./src/pages/material/material.module.ts